export const DEFAULT_TITLE = 'New Task';

export const DEFAULT_DESCRIPTION = `## Task description
Provide an overview of the task and related details.

## Sub-tasks
- First to-do item
- Second to-do item

## Expected output format:
1. Introduction
2. Background
3. Content
4. Conclusion`;
